
  import { useStore } from 'vuex'
  import ActionList from '@/components/ActionList/index.vue'
  import { computed, defineComponent, onBeforeMount, ref, watch } from 'vue'
  import moment from 'moment'
  import { useI18n } from 'vue-i18n'
  import { CompanyModel } from '@/services/api/models'
  import { useRoute, useRouter } from 'vue-router'
  import { ActionListItem, MAINACTIONS } from '@/types'
  import { useAcl } from 'vue-simple-acl/src'
  import { ElTooltip } from 'element-plus'
  export default defineComponent({
    name: 'ContactCard',
    components: {
      ElTooltip,
      ActionList
    },
    directives: {},
    props: {
      contact: {
        type: Object,
        required: true
      },
      noPadding: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    emits: ['delete-contact'],
    setup(props, { emit }) {
      const { t } = useI18n()
      const store = useStore()
      const route = useRoute()
      const router = useRouter()
      const currentCompany = computed<CompanyModel>(
        () => store.getters['organizations/contextCompany']
      )
      const isLoadingImage = ref(false)
      const url = ref()
      const imageUrl = computed(
        () => `${url.value || require('@/assets/images/profile/user.png')}`
      )
      const display = ref(false)
      const acl = useAcl()
      const canDelete = computed(
        () =>
          acl.role('admin') ||
          acl.permission('is-manager') ||
          acl.permission('write-contacts')
      )
      const actionsListItems = ref<ActionListItem[]>([
        {
          name: t('global.actions.edit'),
          action: 'edit',
          children: [],
          icon: '',
          key: MAINACTIONS.EDIT_CONTACT,
          type: ''
        }
      ])

      if (canDelete.value) {
        actionsListItems.value.push({
          name: t('global.actions.delete'),
          action: 'delete',
          children: [],
          icon: '',
          key: MAINACTIONS.DELETE_CONTACT,
          type: ''
        })
      }

      const openContactModal = () => {
        router.push({
          name: 'company.contact',
          params: {
            id: currentCompany.value.id,
            contactId: route.params.contactId
          }
        })
      }
      const handleAction = (key: MAINACTIONS) => {
        if (key === MAINACTIONS.EDIT_CONTACT) {
          openContactModal()
        } else if (key === MAINACTIONS.DELETE_CONTACT) {
          deleteContact()
        }
      }
      const loadImage = async () => {
        url.value = ''
        isLoadingImage.value = true
        const response = await store.dispatch(
          'organizations/LOAD_CONTACT_PICTURE',
          {
            companyId: currentCompany.value.id,
            contactId: props.contact.id
          }
        )
        if (response) url.value = response
        else url.value = ''
        isLoadingImage.value = false
      }

      const deleteContact = () => {
        emit('delete-contact', props.contact.id)
      }
      watch(
        () => props.contact,
        async () => {
          await loadImage()
        }
      )
      onBeforeMount(async () => {
        await loadImage()
      })
      return {
        moment,
        url,
        imageUrl,
        isLoadingImage,
        actionsListItems,
        display,
        handleAction
      }
    }
  })
